import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { singletonGetter } from "@faire/web--source/common/singletons/getter";
export var PreloadedImageTracker = function PreloadedImageTracker() {
    "use strict";
    var _this = this;
    _class_call_check(this, PreloadedImageTracker);
    this.preloadedImageMap = new Map();
    this.getInfo = function(url) {
        var key = getKeyFromUrl(url);
        if (key) {
            return _this.preloadedImageMap.get(key);
        } else {
            return undefined;
        }
    };
    this.setInfo = function(url, info) {
        var key = getKeyFromUrl(url);
        if (key) {
            _this.preloadedImageMap.set(key, info);
        }
    };
    this.clear = function() {
        _this.preloadedImageMap.clear();
    };
};
PreloadedImageTracker.get = singletonGetter(PreloadedImageTracker);
function getKeyFromUrl(urlStr) {
    try {
        var url = new URL(urlStr);
        return url.origin + url.pathname;
    } catch (e) {
        // new URL() will throw an exception if URL is invalid
        return undefined;
    }
}
